import { render } from "./ruduud.vue?vue&type=template&id=5c1f0f2c"
import script from "./ruduud.vue?vue&type=script&lang=js"
export * from "./ruduud.vue?vue&type=script&lang=js"
script.render = render

export default script